import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Controller, } from "react-hook-form";
import { Box, Button, Typography, useMediaQuery, useTheme, } from "@mui/material";
import { colCenter } from "@ui/style/style";
import { Icon } from "@iconify/react";
import { ErrorWithIcon } from "./ValidationMessage";
export const HTabInput = forwardRef(({ control, name, label, defaultValue, rules, options, variant, disabled, color = "success", direction = "column", error, }, ref) => {
    // Removed active state, the value will now depend on the field value directly
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down("md"));
    return (_jsxs(Box, { sx: {
            // background: "#919EAB14",
            borderRadius: 1.5,
            // px: 1.5,
            py: "6.5px",
            display: "flex",
            flexDirection: direction,
            gap: 0.5,
        }, children: [_jsx(Typography, { variant: "subtitle1", fontWeight: 500, color: "#00244D", children: label }), _jsxs(Box, { sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                }, children: [_jsx(Controller, { name: name, control: control, defaultValue: defaultValue, rules: rules, render: ({ field }) => (_jsx(Box, { sx: {
                                ...colCenter,
                                mt: 0.5,
                                flexDirection: isSm ? "column" : "row",
                                gap: 1,
                            }, children: options.map((option, index) => {
                                const isFirst = index === 0;
                                const isLast = index === options.length - 1;
                                return (_jsx(Button, { disabled: disabled, onClick: () => {
                                        field.onChange(option.value); // Update form value directly
                                    }, fullWidth: true, startIcon: field.value === option.value ? (_jsx(Icon, { icon: "eva:checkmark-outline", width: "20", height: "20" })) : undefined, color: field.value === option.value ? "eSuccess" : "ePrimary", variant: field.value === option.value ? "contained" : "outlined", sx: {
                                        borderRadius: 1,
                                    }, children: option.label }, index));
                            }) })) }), _jsx(ErrorWithIcon, { error: error })] })] }));
});
